import { Question } from "./question";

export interface UploadFileQuestion extends Question {
  fileTypes: UploadFileType[];
  fileCount: string;
  fileSize: string;
}

export type UploadFileType = "unity" | "pdf";
